import SimilarAuthorsView from 'react/views/similarAuthors/SimilarAuthorsView';
import AuthorDetails from 'react/views/similarAuthors/AuthorDetails';
import createOverviewDetails from 'react/card/OverviewDetails';


const SimilarAuthorOverviewContainer = createOverviewDetails(SimilarAuthorsView, AuthorDetails);

export default SimilarAuthorOverviewContainer;



// WEBPACK FOOTER //
// ./src/react/views/similarAuthors/SimilarAuthorOverviewContainer.jsx